<template>
  <rect
    :x = "getOffsetX"
    y = "0"
    :width = "Math.max(getOffset + getXAxisGap, 0)"
    :height = "height"
    fill = "white"
    fill-opacity=".5"
    class="offset-block"
  />
  <line
    :x1 = "pipeOffset + getXAxisGap"
    :x2 = "pipeOffset + getXAxisGap"
    :y1 = "0"
    :y2 = "height"
    stroke="#707070"
    stroke-width="1"
  />
  <NESWArrows
    fill = "#707070"
    pointer-events="visible"
    :transform="getGTranslation"
    @mousedown="handleMouseDown"
    @touchstart="handleMouseDown"
    direction="ew"
    offset="true"
  />
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSegmentStore } from '@/store/SegmentStore';
import NESWArrows from '@/components/layout/pipe_editor/pipe_editor_components/NESWArrows';
import {usePrintStore} from '@/store/PrintStore';

export default {
  name: 'OffsetSlider',
  props: [
    'type',
  ],
  data () {
    return {
      startX : 0,
      offsetX : 0
    };
  },
  mounted () {
    useInputStore().initializeOffset(this.$props.type, this);
  },
  components: {
    NESWArrows
  },
  computed: {
    getGTranslation () {
      return 'translate(' + parseInt(this.pipeOffset + this.getXAxisGap) + ','+this.yPixel+')';
    },
    height () {
      return useInputStore().getPressureFlowChartHeight;
    },
    pipeOffset () {
      const inputStore = useInputStore();
      return this.$props.type === 'left'
        ? inputStore.getLeftOffset * this.getMagScale
        : (useSegmentStore().getAllSegmentLengths('pipe') * this.getMagScale) - (inputStore.getRightOffset * this.getMagScale) ;
    },
    getOffset () {
      const inputStore = useInputStore();
      const segmentStore = useSegmentStore();
      return this.$props.type === 'left'
        ? inputStore.getLeftOffset * this.getMagScale
        : ((segmentStore.getAllSegmentLengths('slope') - segmentStore.getAllSegmentLengths('pipe')) * this.getMagScale) + inputStore.getRightOffset * this.getMagScale;
    },
    getOffsetX () {
      return this.$props.type === 'left' ? 0 : (useSegmentStore().getAllSegmentLengths('pipe') - useInputStore().getRightOffset) * this.getMagScale + this.getXAxisGap;
    },
    sliderColor () {
      return '#000000';
    },
    yPixel () {
      return 15;
    },
    getXAxisGap () {
      return useInputStore().getXAxisGap;
    },
    getMagScale () {
      return useSegmentStore().getMagScale;
    },
    getPipeEditorHeight () {
      return useSegmentStore().getPipeEditorHeight;
    },
  },
  methods: {
    handleMouseDown (e) {
      if (e.touches) { e = e.touches[0]; }
      if (usePrintStore().getPrintIsOpen) { return; }
      const inputStore = useInputStore();
      this.offsetX = (this.$props.type === 'left') ? inputStore.getLeftOffset * this.getMagScale : -(inputStore.getRightOffset * this.getMagScale);
      this.startX = (this.$props.type === 'left') ? (e.clientX ) :  (e.clientX) ;
      if (e.radiusX) {
        window.addEventListener('touchmove', this.handleMouseMove);
        window.addEventListener('touchend', this.handleMouseUp);
      } else {
        window.addEventListener('mousemove', this.handleMouseMove);
        window.addEventListener('mouseup', this.handleMouseUp);
      }
    },
    handleMouseMove (e) {
      const segmentStore = useSegmentStore();
      const inputStore = useInputStore();
      if (e.touches) { e = e.touches[0]; }
      let newOffset = ((e.clientX - this.startX) + this.offsetX) / this.getMagScale;

      // left/right offset boundaries
      if (newOffset < 0 && this.$props.type === 'left') { newOffset = 0; }
      let rightOffsetBound = segmentStore.getAllSegmentLengths('pipe') - inputStore.getRightOffset;
      if (newOffset > rightOffsetBound) { newOffset = rightOffsetBound; }
      if (newOffset > 0 && this.$props.type === 'right') { newOffset = 0; }
      let leftOffsetBound = segmentStore.getAllSegmentLengths('pipe')  + newOffset ;
      if (leftOffsetBound < inputStore.getLeftOffset) {
        newOffset = -(segmentStore.getAllSegmentLengths('pipe') - inputStore.getLeftOffset);
      }
      if (this.$props.type === 'left') {
        inputStore.setLeftOffset(newOffset);
      } else {
        inputStore.setRightOffset(-newOffset);
      }
    },
    handleMouseUp (e) {
      useInputStore().sprinklerCalc();
      if (e.touches) {
        window.removeEventListener('touchmove', this.handleMouseMove);
        window.removeEventListener('touchend', this.handleMouseUp);
      } else {
        window.removeEventListener('mousemove', this.handleMouseMove);
        window.removeEventListener('mouseup', this.handleMouseUp);
      }
    },
  }
};
</script>

<style scoped>
.offset-slider {
  cursor: pointer;
}
.offset-block {
  pointer-events: none;
}
</style>